import jQuery from "jquery";
import md5 from "md5";
var nextStr = '';
function openapi_get_url(api, params) {
    const time = new Date().getTime().toString().substr(0, 10);
    const api_url = 'https://open-api.guanhai.com.cn/v1/';
    const appid = 'cteeffcbbd5795c6fa';
    const secret = 'c1eb410c984c43f4a9f93249c9f7dc95';


    params.appid = appid;
    params.time = time;

    const newParams = {};
    Object.keys(params).sort().forEach(function (key) {
        newParams[key] = params[key];
    });

    //生成签名
    //const sign_url = jQuery.param(newParams);
	const sign_url = changeDataType(newParams);
    newParams.sign = md5(md5(sign_url) + appid + secret + time);

    const uri = api_url + api;
    //return uri + "?" + jQuery.param(newParams);
	return uri + "?" + changeDataType(newParams);
}

function openapi_post_url(api, params) {
    const time = new Date().getTime().toString().substr(0, 10);
    const api_url = 'https://open-api.guanhai.com.cn/v1/';
    const appid = 'cteeffcbbd5795c6fa';
    const secret = 'c1eb410c984c43f4a9f93249c9f7dc95';



  params.appid = appid;
    params.time = time;

    const newParams = {};
    Object.keys(params).sort().forEach(function (key) {
        newParams[key] = params[key];
    });

    //生成签名
    //const sign_url = jQuery.param(newParams);
	const sign_url = changeDataType(newParams);
    newParams.sign = md5(md5(sign_url) + appid + secret + time);

    const uri = api_url + api;
    return {
        url:uri + "?sign=" + newParams.sign,
        params:newParams
    };
}


function changeDataType(obj){
    let str = ''
    if(typeof obj == 'object'){
        for(let i in obj){
            if(typeof obj[i] != 'function' && typeof obj[i] != 'object'){
                str += i + '=' + obj[i] + '&' ;
            }else if (typeof obj[i] == 'object'){
                nextStr = '';
                str += changeSonType(i, obj[i])
            }
        }
    }
    return str.replace(/&$/g, '');
}
function changeSonType(objName, objValue){
    if(typeof objValue == 'object'){
        for(let i in objValue){
            if(typeof objValue[i] != 'object'){
                let value = objName + '[' + i + ']=' + objValue[i];
                nextStr += encodeURI(value) + '&';
            }else{
                changeSonType(objName + '[' + i + ']', objValue[i]);
            }
        }
    }
    return nextStr;
}



export {openapi_get_url, openapi_post_url}



// WEBPACK FOOTER //
// ./src/assets/js/Request.js